const STAFF = {
    STAFF_WINDOW: "staff_window",
}

export { STAFF }